module.exports = __webpack_public_path__ + "static/img/MS05.f43d92c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS05.jpg
// module id = 0bhC
// module chunks = 9